var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuteGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93869 2.78926V2.05702C9.93869 1.47006 9.22788 1.18218 8.81781 1.59226L6.38467 4.0254H3.59613C3.42211 4.0254 3.25523 4.09452 3.13218 4.21757C3.00913 4.34062 2.94 4.50751 2.94 4.68152V8.61828C2.94 8.7923 3.00913 8.95919 3.13218 9.08223C3.25523 9.20528 3.42211 9.27441 3.59613 9.27441H4.11145L9.93869 2.78926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81781 11.7075C9.22788 12.1176 9.93869 11.8297 9.93869 11.2428V5.8731L12.2082 3.34731C12.3633 3.17478 12.3491 2.90922 12.1765 2.75419L12.0724 2.66062C11.8999 2.50558 11.6343 2.51977 11.4793 2.69231L3.36071 11.7275C3.20568 11.9 3.21987 12.1656 3.39241 12.3206L3.49654 12.4142C3.66908 12.5692 3.93463 12.555 4.08967 12.3825L6.64755 9.53582L8.81781 11.7075Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteGray);
export default __webpack_public_path__ + "static/media/mute-gray.6a7dccf6573396707d58c18d9ad56df6.svg";
export { ForwardRef as ReactComponent };